export class UrlParsingFailed extends Error {
  constructor() {
    super('Failed to parse URL');
    this.name = 'UrlParsingFailed';
  }
}
